<ng-container *transloco="let t">
  <div
    class="d-flex justify-content-between align-items-stretch event-grid-item__header pe-20"
    [class.finished]="eventItem?.status === EventStatus.FINISHED">
    <div class="event-grid-item__title d-flex align-items-center justify-content-center">
      @if(eventItem?.status === EventStatus.FINISHED) {
      <span class="pe-3 item-status text-uppercase">{{ t("event.item.status.2") }}</span>
      }
      <div [class.finished-title-transform]="eventItem?.status === EventStatus.FINISHED">
        <app-language-output [hrLabel]="eventItem?.name" [enLabel]="eventItem?.nameEng" [itLabel]="eventItem?.nameIta"
                             [siLabel]="eventItem?.nameSlo" [defaultLanguage]="defaultLanguage" [languages]="languages"/>
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-center">
      @if (eventItem?.sportOne) {
        <div class="event-grid-item__type-label trim-text d-flex align-items-center">
          <small>{{ t("app.common.sports." + eventItem?.sportOne) }}</small>
        </div>
      }
      @if (eventItem?.sportTwo) {
        <div class="event-grid-item__type-label trim-text d-flex align-items-center">
          @if (eventItem?.sportTwo) {
            <small>{{ t("app.common.sports." + eventItem?.sportTwo) }}</small>
          }
        </div>
      }
    </div>
  </div>
</ng-container>
